module.exports = __webpack_public_path__ + "img/medical_cover.073f0d03.webp";